// Partidas comentadas (2026-10-18): partidas reales de juegoxima.com explicadas jugada a jugada.
// Las valoraciones salen del análisis del bot (Analizar partida); la notación es la del libro, en modo largo.

export const PARTIDAS_COMENTADAS_GUIDES = [
  {
    slug: "articulos/partida-comentada-power-adrianwrj",
    theme: "estrategia",
    nav: "power contra adrianwrj",
    title: "Partida comentada de XIMA: power contra adrianwrj (Modo Ciencia)",
    description:
      "Una partida real de juegoxima.com explicada jugada a jugada: capturas, un especial atrapado dos veces, el escalón que decidió la partida y el final en la cima.",
    h1: "Partida comentada: power contra adrianwrj",
    intro:
      "La mejor forma de aprender XIMA es ver jugar a los buenos. Esta es una partida real entre dos de los jugadores más fuertes de juegoxima.com, sin dados y a un ritmo rápido. Los dos jugaron con más del 90 % de precisión según el bot, y aun así la partida se decidió por un solo bloque mal colocado.",
    sections: [
      {
        h: "La partida en datos",
        defs: [
          ["Modo", "Ciencia (sin dados), 2 jugadores."],
          ["Fecha", "26 de septiembre de 2026, en juegoxima.com."],
          ["Azul (sale primero)", "power, con un 91 % de precisión."],
          ["Rojo", "adrianwrj, con un 94 % de precisión."],
          ["Duración", "40 jugadas (80 movimientos) en unos 16 minutos."],
          ["Resultado", "0-1: gana adrianwrj llevando su especial a la cima."],
        ],
        after: [
          "La precisión y las valoraciones (?, ?!, !?) salen de Analizar partida, el bot que revisa cada movimiento. Las jugadas se escriben en modo largo: «A12D9» es mover de A12 a D9, «-L1» es incorporar un bloque común en L1, «=F7» es incorporar el especial y la «x» marca una captura. «6... A12D9» quiere decir que es el movimiento de las rojas en la jugada 6.",
          "En los diagramas el tablero se ve desde arriba: azul oscuro es el primer piso, verde azulado el segundo, morado el tercero y la casilla dorada, G7, la cima. El número sobre un bloque dice cuántos hay en esa columna y los cuadritos de abajo son los bloques que quedan debajo; la estrella marca el especial. El recuadro verde señala el último movimiento.",
        ],
      },
      {
        h: "La apertura: los dos llenan los bordes (jugadas 1 a 6)",
        p: [
          "power empieza por abajo con -L1, -K1 y -D1, y luego mete bloques por arriba (-D13) y por la izquierda (-A2). adrianwrj se queda en la esquina de arriba a la izquierda: -A2, -A12, -A11 y, en la jugada 4, apila un segundo bloque en A12 con A2A12. Las primeras jugadas de los dos el bot las da como «de libro»: son las entradas habituales.",
          "Esa pila no es casualidad. Un bloque encima de otro ya está una altura más arriba, y eso es justo lo que hace falta para empezar a subir. Con 5... A11B11 adrianwrj pone además un bloque en B11, y en la jugada 6 lo usa: 6... A12D9 saca el bloque de arriba de la pila de A12, pasa por encima de B11 como si fuera un escalón y llega a D9, ya en el segundo piso.",
          "Es la idea más importante de XIMA: cada piso está dos alturas por encima del anterior y un bloque solo sube una altura por paso, así que para subir de piso necesitas otro bloque que haga de escalón.",
        ],
        figure: "partida-power-adrianwrj-12",
      },
      {
        h: "La primera captura (jugadas 7 y 8)",
        p: [
          "power responde 7. D13B11 y se sube encima del bloque rojo de B11: lo domina. Pero adrianwrj tiene la respuesta preparada. 7... D9xB11 vuelve desde D9 a la misma columna: ahora hay dos rojos y un azul, y el azul queda capturado.",
          "La regla es esta: el que termina el movimiento captura los bloques de los colores que tienen menos que él en esa columna. Dos contra uno captura; uno contra uno solo domina. Por eso, cuando power vuelve a subirse a B11 con 8. C11B11, domina la columna pero ya no puede capturar: es uno contra dos.",
        ],
        figure: "partida-power-adrianwrj-14",
      },
      {
        h: "La lucha en las esquinas (jugadas 9 a 17)",
        p: [
          "Durante unas cuantas jugadas la partida se mueve por los bordes. power acumula bloques en L1 y K1 y los dos se disputan la esquina de abajo a la izquierda. Allí adrianwrj logra la segunda captura de la partida con 16... C3xA3: otra vez dos rojos contra un azul en la misma columna.",
          "La lección se repite: cuando tienes dos bloques en una columna, el rival no puede capturarla con uno solo. Las columnas dobles son las casas seguras de XIMA.",
        ],
      },
      {
        h: "El especial de power entra… y queda atrapado (jugadas 17 a 20)",
        p: [
          "17... B3B10!? es una jugada curiosa de adrianwrj: lleva un bloque desde B3 hasta B10, junto al borde izquierdo. power aprovecha ese bloque rojo como escalón y mete su especial con 18. =C10: entra por A10, pasa por encima de B10 y se queda en C10, en el segundo piso. El bot prefería entrar una casilla más adentro, en D10.",
          "adrianwrj no le da tiempo a moverlo. Con 18... -D8, 19... D8C9 y 20... C9C10 lleva un bloque común justo encima del especial azul. Como es uno contra uno no hay captura, pero solo se mueve el bloque de arriba de cada columna: un especial dominado está congelado. Muchas veces conviene dominar el especial contrario en vez de capturarlo, porque capturado se puede rescatar y volver a entrar en un sitio mejor.",
        ],
        figure: "partida-power-adrianwrj-40",
      },
      {
        h: "El error que decidió la partida (jugadas 21 a 26)",
        p: [
          "adrianwrj prepara la entrada de su propio especial. Con 21... B10B7 deja un bloque en B7, en el primer piso, y 22... -C6?! es la única imprecisión que el bot le señala: era mejor ocupar D7 con -D7.",
          "En la jugada 26 power comete el único error de la partida: 26. D10D7?, que pone un bloque azul justo en D7. Según el bot, esa jugada le quita un 18 % de probabilidad de ganar; lo mejor era D10C11. ¿Por qué es tan grave? Porque ahora la fila 7 tiene escalones en B7 y en D7, y adrianwrj lo ve en el acto.",
          "26... =F7 mete el especial rojo por A7. En un solo movimiento sube por encima del bloque rojo de B7, llega a C7 en el segundo piso, pasa por encima del bloque azul de D7 y sube a E7 y F7, en el tercer piso, al lado de la cima. El bloque que power acababa de poner le sirvió de escalón al especial rival.",
          "Es la lección más útil de esta partida: antes de colocar un bloque, mira si el rival lo puede usar para subir. En XIMA tus bloques también son escalones para el otro.",
        ],
        figure: "partida-power-adrianwrj-52",
      },
      {
        h: "power libera a su especial (jugadas 27 a 32)",
        p: [
          "El especial rojo se aparta a F6 con 27... F7F6 y empieza una pelea en el centro. adrianwrj captura otro bloque azul con 31... F5xE4, pero power encuentra la mejor jugada: 32. E8xC10.",
          "El bloque azul de E8 baja por encima de D9 y cae en la columna de C10, donde estaba el especial azul con el bloque rojo encima. Ahora hay dos azules contra un rojo: el rojo queda capturado y el especial de power vuelve a estar libre.",
        ],
        figure: "partida-power-adrianwrj-63",
      },
      {
        h: "Otra vez atrapado (jugadas 33 y 34)",
        p: [
          "power quita su bloque de encima con 33. C10C11 y saca el especial a D9 con 34. C10D9. Pero adrianwrj contesta en el acto con 34... E8D9 y lo vuelve a tapar con un bloque rojo.",
          "Liberar el especial no basta: hay que sacarlo a una casilla a la que el rival no llegue en la jugada siguiente.",
        ],
      },
      {
        h: "El final: un escalón al lado de la cima (jugadas 35 a 39)",
        p: [
          "Con el especial azul otra vez dominado, adrianwrj ya solo necesita una cosa: un escalón junto a la cima. El especial rojo está en F6, en el tercer piso, pero la cima está dos alturas más arriba y, como siempre, solo se puede subir una por paso.",
          "38... D3G6 lleva un bloque común rojo desde D3, por encima del bloque rojo de E4, hasta G6, justo al lado de la cima. Y 39... F6G6 sube el especial encima de ese bloque.",
        ],
        figure: "partida-power-adrianwrj-78",
      },
      {
        h: "Cima: gana adrianwrj",
        p: [
          "Desde G6 el especial ya está a una sola altura de la cima. power juega 40. D3F5, que según el bot era su mejor jugada, pero ya no hay forma de impedirlo: 40... G6G7 y adrianwrj gana.",
          "adrianwrj no ganó por quitarle más bloques a power, sino por tener el especial cerca de la cima y construir a tiempo el último escalón.",
        ],
        figure: "partida-power-adrianwrj-80",
      },
      {
        h: "Qué aprendemos de esta partida",
        list: [
          "Para subir hacen falta escalones. Una pila de dos bloques en el borde (A12) es la forma más rápida de empezar a subir.",
          "Dos contra uno captura. Las columnas con dos bloques tuyos son difíciles de atacar.",
          "Tus bloques también son escalones para el rival. El error de la jugada 26 fue dejarle a adrianwrj el bloque de D7 en el camino de su especial.",
          "Un especial dominado no se mueve. Mételo cuando el rival no pueda subirse encima, o tenlo cubierto.",
          "En el final, el especial necesita un escalón al lado de la cima. Prepáralo antes de que el rival lo vea venir.",
        ],
      },
      {
        h: "Todas las jugadas",
        table: {
          head: ["N.º", "power (azul)", "adrianwrj (rojo)"],
          rows: [
            ["1.", "-L1", "-A2"],
            ["2.", "-K1", "-A12"],
            ["3.", "-D1", "-A11"],
            ["4.", "-D13", "A2A12"],
            ["5.", "-A2", "A11B11"],
            ["6.", "-C11", "A12D9"],
            ["7.", "D13B11", "D9xB11"],
            ["8.", "C11B11", "A12A2"],
            ["9.", "D1L1", "-B1"],
            ["10.", "-K2", "B1L1"],
            ["11.", "K1K3", "-K1"],
            ["12.", "K2K1", "-A3"],
            ["13.", "-K2", "-B3"],
            ["14.", "K3C3", "A2C4"],
            ["15.", "A2A3", "C4C3"],
            ["16.", "-C4", "C3xA3"],
            ["17.", "C3A3", "B3B10!?"],
            ["18.", "=C10", "-D8"],
            ["19.", "C4C9", "D8C9"],
            ["20.", "B11C11!?", "C9C10"],
            ["21.", "K1K3", "B10B7"],
            ["22.", "K3C3", "-C6?!"],
            ["23.", "C3C6", "K1K3"],
            ["24.", "C9D10", "K3D3!?"],
            ["25.", "C11E9", "B11C11"],
            ["26.", "D10D7?", "=F7"],
            ["27.", "C6D7", "F7F6"],
            ["28.", "D7E8", "C6E4"],
            ["29.", "E8E4", "D3D7"],
            ["30.", "E9E8", "D7F5"],
            ["31.", "D7D9", "F5xE4"],
            ["32.", "E8xC10", "E4E8"],
            ["33.", "C10C11", "B11B7"],
            ["34.", "C10D9", "E8D9"],
            ["35.", "C11C6", "C11C6"],
            ["36.", "K2B2", "B7D7"],
            ["37.", "B2B7", "D7D3"],
            ["38.", "B7D7", "D3G6"],
            ["39.", "D7D3", "F6G6"],
            ["40.", "D3F5", "G6G7 (cima) 0-1"],
          ],
        },
        after: [
          "?: error · ?!: imprecisión · !?: jugada interesante, según el bot. Las demás jugadas el bot las valora como buenas, las mejores posibles o incluso excelentes.",
        ],
      },
    ],
    faqs: [
      ["¿Quién ganó la partida?", "adrianwrj, con las rojas, al llevar su especial a la cima (G7) en la jugada 40."],
      ["¿Cuál fue la jugada clave?", "26. D10D7?: power puso un bloque en D7 que le sirvió de escalón al especial rojo para entrar hasta F7, en el tercer piso."],
      ["¿Cómo puedo analizar mis propias partidas así?", "En juegoxima.com, abre la partida desde Historial y pulsa Analizar partida: el bot valora cada jugada y te enseña la mejor."],
    ],
    related: ["articulos/partida-comentada-yosdel-power", "articulos/partida-comentada-adrianwrj-power", "reglas/subir-bloques", "reglas/dominacion-y-captura", "sistema-de-anotacion", "analizar-partida"],
    cta: { label: "Juega una partida", slug: "partidas-online" },
  },
  {
    slug: "articulos/partida-comentada-yosdel-power",
    theme: "estrategia",
    nav: "yosdel contra power",
    title: "Partida comentada de XIMA: yosdel contra power, tres jugadas brillantes",
    description:
      "Una partida real de XIMA explicada: un especial que entra pronto, queda dominado dos veces y se libera con capturas, y un final con un escalón junto a la cima.",
    h1: "Partida comentada: yosdel contra power",
    intro:
      "Esta partida se jugó en un torneo de práctica de juegoxima.com. yosdel mete su especial muy pronto, power lo atrapa una y otra vez, y la partida se decide por quién sabe liberar su especial y preparar el último escalón. El bot le marca a yosdel tres jugadas brillantes.",
    sections: [
      {
        h: "La partida en datos",
        defs: [
          ["Modo", "Ciencia (sin dados), 2 jugadores, torneo de práctica."],
          ["Fecha", "20 de septiembre de 2026, en juegoxima.com."],
          ["Azul (sale primero)", "yosdel, con un 91,9 % de precisión y 3 jugadas brillantes."],
          ["Rojo", "power, con un 86 % de precisión y 1 jugada brillante."],
          ["Duración", "39 jugadas (77 movimientos) en unos 17 minutos."],
          ["Resultado", "1-0: gana yosdel llevando su especial a la cima."],
        ],
        after: [
          "Las valoraciones (!!, ?, ?!, !?) son del bot de Analizar partida. Las jugadas van en modo largo: «G5G6» es mover de G5 a G6, «-G2» es incorporar un bloque común, «=G3» incorporar el especial y la «x» marca una captura. Si es la primera vez que lees una partida comentada, empieza por la de power contra adrianwrj, donde se explica cómo leer los diagramas.",
        ],
      },
      {
        h: "Una apertura por el centro (jugadas 1 y 2)",
        p: [
          "yosdel no abre en el borde sino en G2, la casilla central del segundo anillo. power aprovecha ese bloque al instante: 1... -G3 entra por G1, pasa por encima del bloque azul de G2 y se queda en G3, ya en el segundo piso. Y yosdel le devuelve la idea con 2. -K6: entra en diagonal por F1, sube sobre G2 y recorre el segundo piso hasta K6.",
          "Es una lección de las primeras jugadas: cualquier bloque en el primer piso es un escalón, también para el rival. El bloque de G2 sirvió a los dos para subir.",
        ],
        figure: "partida-yosdel-power-2",
      },
      {
        h: "El especial entra pronto (jugadas 3 a 13)",
        p: [
          "Durante diez jugadas los dos llenan el segundo piso en el centro de la cara de abajo, alrededor de F3, G3 y G4. En la jugada 13 yosdel mete su especial: 13. =G3 entra por G1 y, de nuevo usando el bloque de G2 como escalón, se coloca en G3, en el segundo piso. Tiene delante una columna de bloques azules en G4 y G5 que apuntan a la cima.",
          "El libro aconseja meter el especial en el segundo o el tercer piso, y eso hace yosdel. power contesta 13... -D5?, que el bot marca como error: prefería -I4.",
        ],
        figure: "partida-yosdel-power-25",
      },
      {
        h: "Dominado, liberado y vuelto a dominar (jugadas 14 a 16)",
        p: [
          "yosdel sube el especial a G4 y, con 15. G4H5?!, al tercer piso. Pero power estaba esperando: 15... J5H5 se sube encima del especial y lo deja congelado.",
          "Entonces llega la primera jugada brillante: 16. I6xH5!!. El bloque azul de I6 cae sobre la columna de H5. Ahora hay dos azules (el especial y el común) contra un rojo, así que el rojo queda capturado.",
        ],
        figure: "partida-yosdel-power-31",
      },
      {
        h: "Las capturas de yosdel (jugadas 16 a 26)",
        p: [
          "power no se rinde y encuentra también una jugada brillante: 16... F5H5!! vuelve a subirse a la columna. Es uno contra dos, así que no captura, pero el especial azul vuelve a quedar tapado, ahora con dos bloques encima.",
          "Con el especial atrapado, yosdel juega con los comunes. 17... -L3? es un error de power y yosdel lo castiga en el acto con 18. F3xC6, la segunda captura. Más tarde llega la tercera con 26. G5xE5. power, mientras tanto, mete su especial en el segundo piso con 24... =K6.",
        ],
      },
      {
        h: "Un escalón junto a la cima (jugadas 27 a 33)",
        p: [
          "27. F5G6!! es la segunda jugada brillante. yosdel pone un bloque en G6, en el tercer piso y justo al lado de la cima. Como la cima está dos alturas por encima del tercer piso, un especial solo puede llegar a ella desde un escalón como ese.",
          "Los dos fallan en esta fase. power juega 27... G8H8? (el bot prefería G8F8) y yosdel, en la jugada 31, retira su propio escalón con 31. G6G5?. power tampoco lo aprovecha: 31... D11J11?! y 32... J11J5?! son dos imprecisiones seguidas.",
        ],
        figure: "partida-yosdel-power-53",
      },
      {
        h: "Una jugada que hace dos cosas (jugada 34)",
        p: [
          "En la jugada 33 power quita su bloque de encima del especial azul con 33... H5G5. Solo queda un bloque azul tapándolo, y yosdel lo mueve con una idea doble: 34. H5I5 deja libre a su especial y, a la vez, se sube encima del especial rojo, que estaba en I5.",
          "Las mejores jugadas de XIMA suelen hacer dos cosas a la vez. Aquí, liberar lo propio y atrapar lo del rival.",
        ],
        figure: "partida-yosdel-power-67",
      },
      {
        h: "El final (jugadas 35 a 39)",
        p: [
          "yosdel reconstruye el escalón con 35. F6G6 y, en la jugada siguiente, juega la tercera brillante: 36. H5G6!! sube el especial encima de él, a una altura de la cima.",
        ],
        figure: "partida-yosdel-power-71",
      },
      {
        h: "Cima: gana yosdel",
        p: [
          "power intenta lo único que le queda: 36... G5G6 se sube encima del especial para taparlo. Pero yosdel tiene otro bloque al lado y contesta 37. G5xG6. Hay dos azules contra un rojo en la columna y el rojo queda capturado: es la cuarta captura de la partida.",
          "Queda un detalle: el especial tiene un bloque azul encima. 38. G6G8 lo quita y, de paso, lo coloca sobre la columna roja de G8. Y 39. G6G7 lleva el especial a la cima.",
          "power no capturó ningún bloque en toda la partida; yosdel capturó cuatro, y dos de esas capturas sirvieron para liberar a su propio especial.",
        ],
        figure: "partida-yosdel-power-77",
      },
      {
        h: "Qué aprendemos de esta partida",
        list: [
          "Un bloque en el primer piso es un escalón para los dos jugadores. Antes de entrar, piensa quién lo va a aprovechar.",
          "Si te dominan el especial, la forma de liberarlo es capturar: lleva un segundo bloque a esa columna y gana el dos contra uno.",
          "Las mejores jugadas hacen dos cosas a la vez, como 34. H5I5: liberar tu especial y atrapar el del rival.",
          "Para llegar a la cima, el especial necesita un escalón en el tercer piso, al lado de G7. Prepáralo y no lo retires sin motivo.",
          "Ten siempre un segundo bloque cerca del especial en el final: si el rival lo tapa en el último momento, podrás capturar y seguir.",
        ],
      },
      {
        h: "Todas las jugadas",
        table: {
          head: ["N.º", "yosdel (azul)", "power (rojo)"],
          rows: [["1.", "-G2", "-G3"], ["2.", "-K6", "-H3"], ["3.", "-C6!?", "-F3"], ["4.", "-A6!?", "H3K6"], ["5.", "-H3", "F3C6"], ["6.", "-F3", "G3F3"], ["7.", "-G3", "F3G3"], ["8.", "F3G4", "-F3"], ["9.", "H3F5", "F3I6"], ["10.", "-F3", "G3G5!?"], ["11.", "F3I6", "G5F5"], ["12.", "G3G5", "-J5"], ["13.", "=G3", "-D5?"], ["14.", "G3G4!?", "K6J5"], ["15.", "G4H5?!", "J5H5"], ["16.", "I6xH5!!", "F5H5!!"], ["17.", "-F3", "-L3?"], ["18.", "F3xC6", "I6G8!?"], ["19.", "K6K4", "J5K4"], ["20.", "C6D5", "G8E8!?"], ["21.", "D5G5", "D5D11"], ["22.", "G4E4", "E8E5?!"], ["23.", "F5E5", "-J5"], ["24.", "C6E4", "=K6"], ["25.", "E4F5", "K6J5!?"], ["26.", "G5xE5", "K4G8"], ["27.", "F5G6!!", "G8H8?"], ["28.", "E5F6", "J5I5?!"], ["29.", "K4G8", "H8H9!?"], ["30.", "G8H9", "-K4"], ["31.", "G6G5?", "D11J11?!"], ["32.", "E5F6", "J11J5?!"], ["33.", "F6G5", "H5G5"], ["34.", "H5I5", "J5F9!?"], ["35.", "F6G6", "K4G8"], ["36.", "H5G6!!", "G5G6"], ["37.", "G5xG6", "F9G8"], ["38.", "G6G8", "J5J4"], ["39.", "G6G7 (cima) 1-0", ""]],
        },
        after: ["!!: jugada brillante · ?: error · ?!: imprecisión · !?: jugada interesante, según el bot."],
      },
    ],
    faqs: [
      ["¿Quién ganó la partida?", "yosdel, con las azules, al llevar su especial a la cima (G7) en la jugada 39."],
      ["¿Cómo se libera un especial dominado?", "Llevando otro bloque tuyo a esa columna para capturar al bloque rival (dos contra uno), o esperando a que el rival lo quite. En esta partida yosdel lo hizo con 16. I6xH5!! y 37. G5xG6."],
    ],
    related: ["articulos/partida-comentada-power-adrianwrj", "articulos/partida-comentada-adrianwrj-power", "reglas/dominacion-y-captura", "reglas/subir-bloques", "estrategia/finales-xima"],
    cta: { label: "Juega una partida", slug: "partidas-online" },
  },
  {
    slug: "articulos/partida-comentada-adrianwrj-power",
    theme: "estrategia",
    nav: "adrianwrj contra power",
    title: "Partida comentada de XIMA: adrianwrj contra power, una victoria en 26 jugadas",
    description:
      "Una partida real de XIMA explicada: apertura Capablanca, cuatro capturas sin perder un bloque y un especial que sube a la cima desde G8.",
    h1: "Partida comentada: adrianwrj contra power",
    intro:
      "Una partida corta y limpia: adrianwrj gana en 26 jugadas con un 96 % de precisión según el bot, sin perder ni un bloque. Es un buen ejemplo de cómo se gana una partida de XIMA paso a paso: columnas dobles, capturas para liberar el especial y un último escalón junto a la cima.",
    sections: [
      {
        h: "La partida en datos",
        defs: [
          ["Modo", "Ciencia (sin dados), 2 jugadores."],
          ["Fecha", "26 de septiembre de 2026, en juegoxima.com."],
          ["Azul (sale primero)", "adrianwrj, con un 96,2 % de precisión."],
          ["Rojo", "power, con un 88,7 % de precisión."],
          ["Duración", "26 jugadas (51 movimientos) en unos 10 minutos."],
          ["Resultado", "1-0: gana adrianwrj llevando su especial a la cima."],
        ],
        after: [
          "Las valoraciones (?!, !?) son del bot de Analizar partida. Las jugadas van en modo largo y la «x» marca una captura. Si es la primera vez que lees una partida comentada, empieza por la de power contra adrianwrj, donde se explica cómo leer los diagramas.",
        ],
      },
      {
        h: "Capablanca contra Capablanca (jugadas 1 a 10)",
        p: [
          "Los dos abren con la Apertura Capablanca: adrianwrj en B1 y power en M2. adrianwrj sigue con -B13 y, en la jugada 3, lleva el bloque de B1 hasta B13 con B1B13: dobla columna. Dos bloques en la misma columna no se pueden capturar con uno solo, y además la pila sirve de escalón.",
          "power intenta molestar en la esquina de arriba a la derecha con 8... M12L13!?, que se sube encima del bloque azul de L13. adrianwrj responde con la pila: 10. B13xL13 recorre toda la fila 13 y cae en L13. Dos azules contra un rojo: primera captura.",
        ],
        figure: "partida-adrianwrj-power-19",
      },
      {
        h: "Subida al centro y entrada del especial (jugadas 11 a 17)",
        p: [
          "adrianwrj lleva sus bloques hacia el centro: 13. L13I10 al segundo piso y 14. L13H9, ya en el tercero. Con el camino preparado, mete el especial: 17. =J9, en el segundo piso y con bloques azules alrededor que lo protegen.",
        ],
        figure: "partida-adrianwrj-power-33",
      },
      {
        h: "Cada vez que power ataca, adrianwrj captura (jugadas 17 a 23)",
        p: [
          "power ataca y pierde el bloque. 17... K8I10!? se sube sobre el bloque azul de I10, y 18. H9xI10 lo captura. 19... K8J9 tapa al especial azul, y 20. H9xJ9 lo captura y libera el especial.",
        ],
        figure: "partida-adrianwrj-power-39",
      },
      {
        h: "La misma idea, otra vez (jugadas 20 a 23)",
        p: [
          "power mete entonces su especial con 20... =H11!? y vuelve a la carga. adrianwrj mueve su especial a I10 con 22. J9I10 y power lo tapa con 22... H11I10. Pero adrianwrj tiene preparado el bloque de H9: 23. H9xI10, tercera captura con la misma idea.",
          "Fíjate en el patrón: adrianwrj siempre tiene un bloque al lado de su especial listo para caer en su columna. Así, cada vez que el rival lo domina, el dos contra uno lo libera.",
        ],
        figure: "partida-adrianwrj-power-45",
      },
      {
        h: "El final: G8 y la cima (jugadas 24 a 26)",
        p: [
          "23... M3K3?! es la única imprecisión que el bot le señala a power (prefería H11D11), pero la partida ya estaba muy cuesta arriba. adrianwrj juega 24. I10G8: quita el bloque de encima de su especial y lo deja en G8, en el tercer piso y al lado de la cima. Es el escalón final.",
        ],
        figure: "partida-adrianwrj-power-47",
      },
      {
        h: "Cima: gana adrianwrj",
        p: [
          "25. I10G8 sube el especial encima de ese bloque. power mueve su especial a I10, pero ya no hay tiempo: 26. G8G7 lleva el especial azul a la cima.",
        ],
        figure: "partida-adrianwrj-power-51",
      },
      {
        h: "Qué aprendemos de esta partida",
        list: [
          "Doblar columna pronto (3. B1B13) da un bloque fuerte que el rival no puede capturar y que sirve de escalón.",
          "Si el rival se sube a uno de tus bloques, busca el dos contra uno: un segundo bloque en esa columna captura.",
          "Mete el especial cuando tengas bloques alrededor para defenderlo.",
          "Ten siempre un bloque al lado del especial: es la forma de liberarlo si lo dominan.",
          "El último paso es un escalón en el tercer piso junto a G7. adrianwrj lo puso en G8 con el bloque que tenía encima de su especial.",
        ],
      },
      {
        h: "Todas las jugadas",
        table: {
          head: ["N.º", "adrianwrj (azul)", "power (rojo)"],
          rows: [["1.", "-B1", "-M2"], ["2.", "-B13", "-M12"], ["3.", "B1B13", "-M3"], ["4.", "-C12", "-C10"], ["5.", "-C11", "C10D11"], ["6.", "C12M12", "-M4!?"], ["7.", "-L13!?", "M4M2"], ["8.", "M12M2", "M12L13!?"], ["9.", "-K13", "-L3"], ["10.", "B13xL13", "M3K3"], ["11.", "C11D11", "-M3"], ["12.", "-K12", "K3K11!?"], ["13.", "L13I10", "M3K3"], ["14.", "L13H9", "-J11"], ["15.", "D11J11", "-M3"], ["16.", "K12G12", "K3K8"], ["17.", "=J9", "K8I10!?"], ["18.", "H9xI10", "K11K8"], ["19.", "I10H9", "K8J9"], ["20.", "H9xJ9", "=H11!?"], ["21.", "J9H9", "D11H11"], ["22.", "J9I10", "H11I10"], ["23.", "H9xI10", "M3K3?!"], ["24.", "I10G8", "K3K10"], ["25.", "I10G8", "H11I10"], ["26.", "G8G7 (cima) 1-0", ""]],
        },
        after: ["?!: imprecisión · !?: jugada interesante, según el bot."],
      },
    ],
    faqs: [
      ["¿Quién ganó la partida?", "adrianwrj, con las azules, al llevar su especial a la cima (G7) en la jugada 26."],
      ["¿Qué apertura se jugó?", "Los dos abrieron con la Apertura Capablanca: adrianwrj en B1 y power en M2."],
    ],
    related: ["articulos/partida-comentada-power-adrianwrj", "articulos/partida-comentada-yosdel-power", "estrategia/apertura-capablanca", "reglas/dominacion-y-captura", "estrategia/finales-xima"],
    cta: { label: "Juega una partida", slug: "partidas-online" },
  },
];
